import axios from '../_helpers/axios'

const route = 'images'
const create = async (createBody) =>
  axios.post(`v1/${route}`, createBody, { transformRequest: () => createBody })
export default {
  create,
}
